import { useRef, useImperativeHandle, forwardRef } from 'react';
import { Image, Link, Text } from '@weareconceptstudio/core';

import { config } from '@/helpers';

//! If you make a change, also change it in "Preloader & Infinite Scroll Append".
const loadCount = 12;

const Item = forwardRef(({ item, handleMouseEnter, handleMouseLeave, index, percent, isAnimationList = false }, ref) => {
	const itemRef = useRef();

	useImperativeHandle(ref, () => itemRef.current);

	return (
		<div
			ref={itemRef}
			className={`element-block`}
			onMouseEnter={handleMouseEnter || null}
			onMouseLeave={handleMouseLeave || null}
		>
			<Link
				className='element-link-block'
				url={`${config.routes.portfolio.path}${item.slug}`}
			>
				<div className='element-inner-block'>
					<span className='before-layer' />
					<span className='after-layer' />

					<div className='image-block'>
						<div className='image-inner-block'>
							<Image
								priority={index < loadCount || percent === 100}
								src={item.image.src}
								alt={item.image.alt}
								sizes='(max-width: 1023px) 50%, 33vw'
							/>
						</div>
					</div>

					{!isAnimationList ? (
						<div className='text-info-block'>
							<div className='text-info-inner-block'>
								{item.featured_title ? (
									<div className='hidden-container'>
										<Text className='p2 white-1000 font-ogg-medium featured-title align-center'>{item.featured_title}</Text>
									</div>
								) : null}

								{item.location ? <Text className='p5 white-1000 font-neue-roman featured-location align-center'>{item.location}</Text> : null}
							</div>
						</div>
					) : null}
				</div>
			</Link>
		</div>
	);
});

export default Item;
